module.exports = __webpack_public_path__ + "static/media/hand_mobile_2x.28156617.png";


//////////////////
// WEBPACK FOOTER
// ./src/sass/images/landpage/hand_mobile_2x.png
// module id = 302
// module chunks = 0